/* 🤖 this file was generated by svg-to-ts */
export const mgcIconEdit3Filled: {
  name: 'edit-3-filled';
  data: string;
} = {
  name: 'edit-3-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.94 2.482c-.253.051-.501.15-.698.278-.1.064-2.58 2.516-5.51 5.449-3.994 3.996-5.363 5.39-5.469 5.566-.266.446-.267.469-.254 3.665l.011 2.86.111.189c.125.213.318.375.539.454.123.044 1.598.054 8.313.055 9.163.002 8.393.028 8.718-.297.174-.174.299-.458.299-.681a1.08 1.08 0 0 0-.299-.721c-.314-.315-.075-.299-4.618-.299h-4.022l4.583-4.59c4.457-4.465 4.585-4.598 4.707-4.87a1.993 1.993 0 0 0-.016-1.74c-.139-.288-.241-.396-2.49-2.643-2.557-2.555-2.534-2.535-3.114-2.658a1.865 1.865 0 0 0-.791-.017"/></svg>`
};
